module.exports = __webpack_public_path__ + "img/media-library-upload.c58fccf8.png";